import { navigation } from '@exploration/cms-constants';

export const getDefaultData = () => ({
  callToAction: {
    [navigation.resources_navigation_links.insights_and_guidance]: {
      href: 'https://www.thrivent.com/insights',
      text: 'Insights & Guidance',
    },
    [navigation.resources_navigation_links.financial_education_events]: {
      href: 'https://www.thrivent.com/financial-education-events',
      text: 'Financial Education Events',
    },
    [navigation.resources_navigation_links.market_and_economic_updates]: {
      href: 'https://www.thrivent.com/market-economic-update',
      text: 'Market & Economic Update',
    },
    [navigation.resources_navigation_links.tools_and_calculators]: {
      href: 'https://www.thrivent.com/tools-and-calculators',
      text: 'Tools & Calculators',
    },
    [navigation.resources_navigation_links.client_resources]: {
      href: 'https://www.thrivent.com/client-resources',
      text: 'Client Resources',
    },
    [navigation.resources_navigation_links.contact_us]: {
      href: 'https://www.thrivent.com/about-us/support',
      text: 'Contact Us',
    },
    [navigation.resources_navigation_links.faqs]: {
      href: 'https://www.thrivent.com/about-us/faq',
      text: 'FAQs',
    },
    [navigation.resources_promo_card.resources_promo_card_call_to_action]: {
      href: 'https://www.thrivent.com/forms',
      text: 'Search forms',
      target: '_self',
    },
  },
  image: {},
  list: {},
  text: {
    [navigation.resources_navigation_links.resources_learn_title]: 'Learn',
    [navigation.resources_navigation_links.resources_get_help_title]:
      'Get help',
    [navigation.resources_navigation_links.resources_description]:
      'Tools, calculators, FAQs, market insights & more',
    [navigation.resources_promo_card.resources_promo_card_title]:
      'Looking for a specific form?',
    [navigation.resources_promo_card.resources_promo_card_description]:
      'Get quick access and download important forms or access online applications below.',
    [navigation.resources_navigation_links.resources_title]: 'Resources',
  },
  video: {},
});
